import { Box, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  title: ReactNode | undefined;
  subtitle?: ReactNode;
  actions?: ReactNode;
  primaryActions?: ReactNode;
  secondaryActions?: ReactNode;
  closeAction?: ReactNode;
}

export default function SimpleViewPageHeader({
  title,
  subtitle,
  actions,
  primaryActions,
  secondaryActions,
  closeAction,
}: Props) {
  return (
    <Stack
      data-testid='SimpleViewPageHeader'
      sx={{
        flexDirection: { xxs: "column", md: "row" },
        alignItems: { xxs: "flex-start", md: "center" },
        justifyContent: { xxs: "center", md: "flex-start" },
        gap: 1,
        backgroundColor: "transparent",
      }}
    >
      <Box sx={{ flex: 1, overflow: "hidden" }}>
        <Typography variant='h1' sx={{ wordBreak: "break-word" }}>
          {title}
        </Typography>

        {subtitle && (
          <Typography component='div' variant='subtitle1' color='text.secondary'>
            {subtitle}
          </Typography>
        )}
      </Box>

      {(actions || primaryActions || secondaryActions || closeAction) && (
        <Stack direction='row' gap={1} sx={{ justifyContent: "flex-end", alignSelf: "flex-end" }}>
          <Stack direction='row' gap={1} sx={{ alignItems: "center" }}>
            {primaryActions}
            {actions}
            {secondaryActions}
            {closeAction}
          </Stack>
        </Stack>
      )}
    </Stack>
  );
}
